'use client';

import { Film } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface PostsListProps {
  onTogglePreview: () => void;
  postCount?: number;
}

export function PostsList({ onTogglePreview, postCount = 0 }: PostsListProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={onTogglePreview}
            className="h-8 gap-2 hover:bg-accent"
          >
            <Film className="h-4 w-4" />
            {postCount > 0 && (
              <Badge
                variant="secondary"
                className="h-5 min-w-5 rounded-full px-1.5 text-[10px] font-medium"
              >
                {postCount}
              </Badge>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p>View recent posts</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
